(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    (() => {
    'use strict';

    if (customElements.get('duopro-card-unit-price')) return;

    class DuoproCardUnitPrice extends HTMLElement {
      connectedCallback() {
        if (this.dataset.native === 'true') return;

        const footer = this.closest('.card-footer');
        if (!footer) return;

        // If the theme already knows an amount, preserve it.
        const existing = footer.querySelector('.unit-price, .price__unit-price, .price-unit, .price__unit');
        if (existing) {
          const pack = this.parsePackaging(this.dataset.package);
          if (pack) this.renameUnit(existing, pack.unit);
          return;
        }

        const pack = this.parsePackaging(this.dataset.package);
        const price = Number(this.dataset.price);

        if (!pack || !Number.isSafeInteger(price) || price < 0) return;

        let formatted;
        try {
          formatted = new Intl.NumberFormat('nl-NL', {
            style: 'currency',
            currency: this.dataset.currency || 'EUR',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(price / pack.quantity / 100);
        } catch (_) {
          return;
        }

        this.textContent = formatted + ' / ' + pack.unit;
        this.hidden = false;
        footer.classList.add('duopro-unit-ready');
      }

      renameUnit(element, unit) {
        const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
        let node;
        while ((node = walker.nextNode())) {
          const current = node.nodeValue || '';
          if (/\b(?:item|stuk|stuks)\b/i.test(current)) {
            node.nodeValue = current.replace(/\b(?:item|stuk|stuks)\b/i, unit);
            break;
          }
        }
      }

      parsePackaging(value) {
        const raw = String(value || '').replace(/\u00a0/g, ' ').trim();
        // Accept only explicitly expressed packaging counts.
        const prefix = '(?:(?:doos|pak|pack|verpakking|zak|bundel|box)\\s*:\\s*)?';
        const unit = '(rollen|rol|stuks?|units?|items?|paren|paar|sets?)';
        const clean = raw.replace(/\s+/g, ' ');

        let m = clean.match(new RegExp('^' + prefix + '(\\d+)\\s*(?:sets?|dozen|pakken|verpakkingen)\\s+(?:van|met)\\s*(\\d+)\\s*' + unit + '$', 'i'));
        if (m) return this.packageResult(Number(m[1]) * Number(m[2]), m[3]);

        m = clean.match(new RegExp('^' + prefix + '(\\d+)\\s*[x×]\\s*(\\d+)\\s*' + unit + '$', 'i'));
        if (m) return this.packageResult(Number(m[1]) * Number(m[2]), m[3]);

        m = clean.match(new RegExp('^' + prefix + '(\\d+)\\s*' + unit + '$', 'i'));
        if (m) return this.packageResult(Number(m[1]), m[2]);

        return null;
      }

      packageResult(quantity, kind) {
        if (!Number.isSafeInteger(quantity) || quantity <= 0) return null;
        let unit = 'stuk';
        if (/rol/i.test(kind)) unit = 'rol';
        else if (/paar|paren/i.test(kind)) unit = 'paar';
        else if (/set/i.test(kind)) unit = 'set';
        return { quantity, unit };
      }
    }

    customElements.define('duopro-card-unit-price', DuoproCardUnitPrice);
  })();
  } catch(e) { console.error(e); }
})();

})();
